import React from 'react';
import styles from './styles.module.scss';
import { BlockContainer } from '../../components/layouts';
import { AppImage, RichText } from '../../components';
import type { SharedBlockType } from '../types';
import type { Image as ImageType } from '../../graphql/generated/schema';

export const Image: React.FC<SharedBlockType & ImageType> = ({
  image,
  caption,
  blockSettings,
  imageSize,
  parentBlockType,
}) => (
  <BlockContainer
    blockSettings={blockSettings}
  >
    <AppImage
      className={styles.appImage}
      imageSize={imageSize || 'feature'}
      image={image}
      hideLoadingState={parentBlockType === 'SliderWithBlocks'}
    />
    {
      caption && (
        <RichText
          data={caption}
        />
      )
    }
  </BlockContainer>
);
